import { formatMoney } from "@/lib/format-money";

/**
 * Plan / subscription price in the UI locale (P17): whole amounts without
 * decimals ("54 €", "€54"), anything else with two ("12,50 €"). One format
 * for the billing view, the subscription card and the subscribe flow.
 */
export function formatPrice(amount: number, currency: string | null | undefined, locale: string) {
  const whole = Math.round(amount * 100) % 100 === 0;
  return formatMoney(
    amount,
    currency || "EUR",
    locale,
    whole
      ? { minimumFractionDigits: 0, maximumFractionDigits: 0 }
      : { minimumFractionDigits: 2, maximumFractionDigits: 2 },
  );
}
